<template>
  <div class="global-navi-user">
    <a v-if="viewer.id" :href="viewer.url" class="global-navi-user-link">
      <div class="global-navi-user-img">
        <div class="global-navi-img">
          <image-viewer
            :src="viewer.imageUrl || noImage"
            :alt-src="noImage"
            :alt="viewer.nickname + 'さん'"
            :small-light-params="smallLightParams"
            />
        </div>
      </div>
      <div class="global-navi-user-name">
        <span class="global-navi-nickname">{{viewer.nickname}}</span><span class="global-navi-mr-mrs">さん</span>
        <div class="global-navi-user-profile">プロフィールをみる</div>
      </div>
    </a>
    <div v-if="memberRank" class="global-navi-user-member-rank-wrap">
      <a :href="userPageUrl" class="global-navi-user-member-rank-link">
        <div class="global-navi-user-member-rank">
          <component :is="memberRankIcon" class="global-navi-user-member-rank-icon"/>
          <p class="global-navi-user-member-rank-name">{{ memberRankLabel }}
            <span v-if="memberRank.isPremium" class="global-navi-user-member-rank-name-sub">(プレミアム会員 {{ memberRank.premiumCourse }})</span>
          </p>
        </div>
      </a>
      <div class="global-navi-user-member-rank-about"><a :href="shoppingProgramUrl" class="global-navi-user-member-rank-about-link">ランクアップ特典はこちら</a></div>
    </div>
  </div>
</template>

<script>
import Config                  from '../../../libs/config';
import UidWebGatewayApiClient  from '../../../libs/uid-web-gateway-api-client';
import ErrorReporter           from '@istyle-inc/js-error-reporter/vue-error-reporter';
import ImageViewer             from '@istyle-inc/media-component/components/image-viewer';
import globalNavigation        from '../../../store/global-navigation';
import SvgIconUserrankStandard from '@istyle-inc/common-icon/src/svg/c-icon-userrank-standard.inline.svg';
import SvgIconUserrankGold     from '@istyle-inc/common-icon/src/svg/c-icon-userrank-gold.inline.svg';
import SvgIconUserrankPlatinum from '@istyle-inc/common-icon/src/svg/c-icon-userrank-platinum.inline.svg';
import SvgIconUserrankVip      from '@istyle-inc/common-icon/src/svg/c-icon-userrank-vip.inline.svg';
import SvgIconUserrankOther    from '@istyle-inc/common-icon/src/svg/c-icon-userrank-other.inline.svg';
import SideMenuItem            from './side-menu-item';

export default {
  name      : 'side-menu-profile',
  mixins    : [SideMenuItem, ErrorReporter],
  components: {
    ImageViewer,
    SvgIconUserrankStandard,
    SvgIconUserrankGold,
    SvgIconUserrankPlatinum,
    SvgIconUserrankVip,
    SvgIconUserrankOther,
  },
  data() {
    return {
      noImage           : `https://${Config.SMALL_LIGHT_HOST}/images/user/characters/no_image/noimage_wl.gif`,
      smallLightParams  : { da: 's', ds: 'n', dw: 120, dh: 120, cc: 'FFFFFF', cw: 120, ch: 120 },
      userPageUrl       : Config.SERVICE_LINK.ATCOSME.USER.URL,
      shoppingProgramUrl: Config.ATCOSME_SHOPPING_URL + 'static/rank/',
      memberRank        : null,
      activated         : false,
    };
  },
  computed: {
    viewer: function() {
      return (this.$store.state.globalNavigation || {}).profile || {};
    },
    memberRankIcon: function() {
      return {
        11   : SvgIconUserrankStandard,
        12   : SvgIconUserrankGold,
        13   : SvgIconUserrankPlatinum,
        14   : SvgIconUserrankVip,
        10007: SvgIconUserrankOther,
        10008: SvgIconUserrankOther,
      }[this.memberRank.id];
    },
    memberRankLabel: function () {
      return `${this.memberRank.label}会員`;
    }
  },
  watch: {
    active: function() {
      if (this.active) {
        this.activated = true;
      }
    },
    activated: function() {
      this.fetchMemberRank();
    }
  },
  updated() {
    this.$emit('loaded');
  },
  beforeMount() {
    if (!this.$store.state.globalNavigation) {
      this.$store.registerModule('globalNavigation', globalNavigation);
    }
    this.$store.dispatch('globalNavigation/profile/fetchSelf')
      .catch((error) => this.report('Load account failed', error));
  },
  methods: {
    fetchMemberRank: function() {
      const apiClient = new UidWebGatewayApiClient();

      return apiClient.getMemberRank()
        .then((result) => {
          this.memberRank = {
            id           : result.memberRankId,
            label        : result.memberRankName,
            isPremium    : result.isPremium,
            premiumCourse: result.premiumCourse
          };
        })
        .catch((error) => {
          this.report('Load uid-web-gateway-api failed', error);
          this.memberRank = null;
        });
    }
  }
};
</script>
